const IndexCell = ({ rowIndex, useQueryRequest, className }: any) => {
  const { state } = useQueryRequest?.() ?? { state: {} }
  const page = (state?.page ?? 1) - 1
  const pageSize = state?.items_per_page

  const index = pageSize ? (page * pageSize) + rowIndex + 1 : rowIndex + 1

  return <span className={className}>{index}</span>
}

export { IndexCell }
